// components/settings-slot.js — Settings panel wiring
// ═══════════════════════════════════════════════════════
// Extracted from pages/index.js inline IIFE. Wires all
// the settings actions (clear, export, save) to the API
// so the shell doesn't carry 20 lines of dense callbacks.
// ═══════════════════════════════════════════════════════

import SettingsPanel from '../features/settings-panel';

export default function SettingsSlot({
  session,
  supabase,
  userRecord,
  setUserRecord,
  settingsTab,
  setSettingsTab,
  threadHistory,
  setThreadHistory,
  onClose,
}) {
  const authHeaders = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${session?.access_token || ''}`,
  };

  async function apiCall(action, payload) {
    const res = await fetch('/api/user/update', {
      method: 'POST',
      headers: authHeaders,
      body: JSON.stringify({ action, ...(payload ? { payload } : {}) }),
    });
    if (!res.ok) throw new Error(await res.text());
    return res;
  }

  return (
    <SettingsPanel
      settingsTab={settingsTab}
      setSettingsTab={setSettingsTab}
      session={session}
      supabase={supabase}
      userRecord={userRecord}
      setUserRecord={setUserRecord}
      onClose={onClose}
      clearHistory={async () => {
        try { await apiCall('clear_history'); setThreadHistory([]); }
        catch (e) { console.error('clearHistory failed:', e); alert('Could not clear history. Please try again.'); }
      }}
      clearIdeas={async () => {
        try { await apiCall('clear_ideas'); setUserRecord(prev => ({ ...prev, ideas: [] })); }
        catch (e) { console.error('clearIdeas failed:', e); alert('Could not clear ideas. Please try again.'); }
      }}
      clearPortrait={async () => {
        try { await apiCall('clear_portrait'); setUserRecord(prev => ({ ...prev, portrait_v2: null })); }
        catch (e) { console.error('clearPortrait failed:', e); alert('Could not clear portrait. Please try again.'); }
      }}
      deleteAccount={async () => {
        try { await apiCall('delete_account'); await supabase.auth.signOut(); }
        catch (e) { console.error('deleteAccount failed:', e); alert('Could not process deletion. Please try again.'); }
      }}
      exportData={async () => {
        try {
          const res = await apiCall('export_data');
          const { data } = await res.json();
          const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'shift-data.json';
          a.click();
        } catch (e) { console.error('exportData failed:', e); alert('Could not export data. Please try again.'); }
      }}
      nameEdit={userRecord?.ai_name || 'Shift'}
      setNameEdit={() => {}}
      saveAiName={async (name) => {
        try { await apiCall('save_ai_name', { name }); setUserRecord(prev => ({ ...prev, ai_name: name })); }
        catch (e) { console.error('saveAiName failed:', e); alert('Could not save AI name. Please try again.'); }
      }}
      savePreferences={async (prefs) => {
        try {
          const res = await fetch('/api/user/preferences', {
            method: 'POST',
            headers: authHeaders,
            body: JSON.stringify({ preferences: prefs }),
          });
          if (!res.ok) throw new Error(await res.text());
          setUserRecord(prev => ({ ...prev, preferences: { ...(prev.preferences || {}), ...prefs } }));
        } catch (e) { console.error('savePreferences failed:', e); alert('Could not save preferences. Please try again.'); }
      }}
      settingsFirstName={userRecord?.first_name || ''}
      settingsLastName={userRecord?.last_name || ''}
      setSettingsFirstName={() => {}}
      setSettingsLastName={() => {}}
      usernameInput={userRecord?.username || ''}
      setUsernameInput={() => {}}
      saveUsernameFromSettings={async (username) => {
        try { await apiCall('save_username', { username }); setUserRecord(prev => ({ ...prev, username })); }
        catch (e) { console.error('saveUsername failed:', e); alert('Could not save username. Please try again.'); }
      }}
    />
  );
}
